import { render, staticRenderFns } from "./ProductExtraOptionTypeSelector.vue?vue&type=template&id=6a9653d2&"
import script from "./ProductExtraOptionTypeSelector.vue?vue&type=script&lang=js&"
export * from "./ProductExtraOptionTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports